/**
 * @param flightId セグメントIDが項目名となる
 * @param passengerId 搭乗者IDが項目名となる。DxAPIから返却された順（順不同）で返却
 */
export interface CallCenterRequestBaggage {
  [flightId: string]: CenterRequestBaggageSegmentInfor;
}

/**
   * @param code SSRコード
   * @param serviceStatus 
      SSRステータスに応じたサービスの申込状態<br/>
      confirmed：申込み確定。<br/>
      SSRのステータスがHK/KKのいずれか<br/>
      requesting：<br/>
      SSRのステータスがHNの場合<br/>
      cancelled：<br/>
      SSRのステータスがUN/NO/UCの場合
   * @param attributes
      フリーテキスト中に含まれる可変要素のリスト<br/>
      (例：50x60x30cm 20kgのようなフリーテキストがあった場合、<br/>
      50,60,30,20の部分が「HEIGHT」=50,「WIDTH」=60,「DEPTH」=30,「LENGTHUNIT」=20のようなKEY-VALUE形式で<br/>
      DxAPIより返却されるので「HEIGHT」,「WIDTH」,「DEPTH」,「LENGTHUNIT」の順に配列にセットし、<br/>
      その部分の値をリストとして返す)
   * @param freetext フリーテキスト
   */

export interface CenterRequestBaggageSegmentInfor {
  [passengerId: string]: CenterRequestBaggagePassengerInfor;
}

export interface CenterRequestBaggagePassengerInfor {
  code?: string;
  serviceStatus?: CallCenterRequestBaggage.ServiceStatusEnum;
  attributes?: Array<string>;
  freetext?: string;
}

export namespace CallCenterRequestBaggage {
  export type ServiceStatusEnum = 'confirmed' | 'requesting' | 'cancelled';
  export const ServiceStatusEnum = {
    Confirmed: 'confirmed' as ServiceStatusEnum,
    Requesting: 'requesting' as ServiceStatusEnum,
    Cancelled: 'cancelled' as ServiceStatusEnum,
  };
}

/**
 * @param flightId バウンドIDが項目名となる
 */

export interface FirstBaggagePnr {
  [flightId: string]: FirstBaggageSegmentMap;
}

/**
 * @param isAvailable バウンド毎の申込可否
 * 申込可否がtrueである搭乗者が当該バウンド内の全セグメントに存在しない場合false。それ以外の場合true
 */
export interface FirstBaggageSegmentMap {
  isAvailable?: boolean;
  [key: string]: FirstBaggagePassengerMap | boolean | undefined;
}

/**
 * @param code 有料ラウンジのSSRコード
 * @param statusCode 有料ラウンジのSSRステータスコード
 * @param serviceStatus 有料ラウンジのSSRステータスとAncillaryのEMDの状態に応じたサービスの申込状態
 * @param isMyLoungeRequested 空港ラウンジが申し込まれているか
 * @param isWaived 申し込み不要で利用できるかどうか
 * @param isAvailable 有料ラウンジの申込可否
 * @param prices 有料ラウンジの申込済みの金額情報
 * @param catalogue 有料ラウンジのサービスカタログ
 */
export interface FirstBaggagePassengerMap {
  id?: string;
  serviceStatus?: FirstBaggagePassengerMap.ServiceStatusEnum;
  isAvailable?: boolean;
  prices?: PriceInfo;
  catalogue?: Catalogue;
}

export namespace FirstBaggagePassengerMap {
  export type ServiceStatusEnum =
    | 'hasDiscrepancy'
    | 'confirmed'
    | 'prebooked'
    | 'confirmedWithoutTsm'
    | 'cancelled'
    | 'notRequested'
    | 'unavailable'
    | 'requested';
  export const ServiceStatusEnum = {
    HasDiscrepancy: 'hasDiscrepancy' as ServiceStatusEnum,
    Confirmed: 'confirmed' as ServiceStatusEnum,
    Prebooked: 'prebooked' as ServiceStatusEnum,
    ConfirmedWithoutTsm: 'confirmedWithoutTsm' as ServiceStatusEnum,
    Cancelled: 'cancelled' as ServiceStatusEnum,
    NotRequested: 'notRequested' as ServiceStatusEnum,
    Unavailable: 'unavailable' as ServiceStatusEnum,
    Requested: 'requested' as ServiceStatusEnum,
  };
}

/**
 * 申込済みの金額情報
 * @param total 総額
 * @param currencyCode 通貨コード
 */
export interface PriceInfo {
  total?: number;
  currencyCode?: string;
}

/**
     * @param prices
     * 申込済みの金額情報<br/>
        ※カート情報のservicesより取得した金額情報を返却する
     * @param catalogue サービスカタログ
     */
export interface PassengerBaggageInfor {
  prices?: PricesApplied;
  catalogue?: Catalogue;
}

/**
 * 申込済みの金額情報
 * @param total 総額
 * @param currencyCode 通貨コード
 */
export interface PricesApplied {
  total: number;
  currencyCode: string;
}

/**
 * サービスカタログ
 * @param prices 金額情報。申込可否がtrueの場合のみ返却する。
 */
export interface Catalogue {
  prices: Prices;
}

/**
 * 金額情報
 * @param total 総額
 * @param currencyCode 通貨コード
 */
export interface Prices {
  total: number;
  currencyCode: string;
}
